import { displayText } from '../../../terminology/store';
import { useTerminology } from '../../../terminology/TerminologyContext';
  // src/components/WebManager/Dashboard/ClientUserDashboard.js

  import React, { useState, useEffect, useContext } from 'react';
  import { useNavigate, useLocation, useParams, Outlet } from 'react-router-dom';
  import ThemeContext from '../../ThemeContext';
  import CaseManagement from '../pages/CaseManagement';   // ← Your Cases listing page
  import Account from '../pages/Account';
  import ClientConfig from '../../../config/Clientconfig';
  import { URL_SEGMENTS } from '../../../config/Routesconfig';

  const ClientUserDashboard = () => {
  useTerminology();
    const { theme } = useContext(ThemeContext);

    const [activeTab, setActiveTab] = useState('cases');
    const [currentUser] = useState(JSON.parse(localStorage.getItem('user')) || {});
    const [error, setError] = useState('');

    const navigate = useNavigate();
    const location = useLocation();
    const { username } = useParams();

    const fontFamily = theme.typography?.fontFamily || '"Roboto", "Helvetica Neue", Arial, sans-serif';
    const bodyFontSize = theme.typography?.bodyFontSize || 14;

    useEffect(() => {
      const pathSegments = location.pathname.split('/').filter(Boolean);
      const dashboardIndex = pathSegments.indexOf('user-dashboard');
      const subPath = pathSegments.slice(dashboardIndex + 1);

      let newTab = 'cases';

      if (subPath[0] === URL_SEGMENTS.account) {
        newTab = 'account';
      } else if (subPath[0] === URL_SEGMENTS.cases || 
                subPath[0] === URL_SEGMENTS.addCase || 
                subPath[0] === URL_SEGMENTS.editCase || 
                subPath[0] === URL_SEGMENTS.viewCase) {
        newTab = 'cases';
      }

      setActiveTab(newTab);

      // Default route → cases
      if (subPath.length === 0) {
        navigate(`/${username}/user-dashboard/${URL_SEGMENTS.cases}`, { replace: true });
      }
    }, [navigate, location, username]);

    const handleTabClick = (tab) => {
      setActiveTab(tab);
      const segmentMap = {
        cases: URL_SEGMENTS.cases,
        account: URL_SEGMENTS.account,
      };
      navigate(`/${username}/user-dashboard/${segmentMap[tab]}`);
    };

    const renderContent = () => {
      // Show nested routes (Add Case, Edit Case, View Case, etc.)
      if (
        location.pathname.includes(`/${URL_SEGMENTS.addCase}`) ||
        location.pathname.includes(`/${URL_SEGMENTS.editCase}`) ||
        location.pathname.includes(`/${URL_SEGMENTS.viewCase}`)
      ) {
        return <Outlet />;
      }

      switch (activeTab) {
        case 'cases':
          return <CaseManagement />;
        case 'account':
          return (
            <Account
              currentUser={currentUser}
              setCurrentUser={() => {}}   // Client User may not need to update user here
              setError={setError}
            />
          );
        default:
          return <div>No content available.</div>;
      }
    };

    return (
      <div
        style={{
          fontFamily,
          fontSize: `${bodyFontSize}px`,
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        {/* Tabs */}
        <div
          style={{
            display: 'flex',
            gap: '0.5rem',
            marginBottom: '1rem',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}
        >
          {/* Cases Tab */}
          <button
            style={{
              flex: '1 1 0',
              minWidth: '120px',
              padding: '0.5rem',
              fontSize: `${bodyFontSize}px`,
              fontWeight: 'bold',
              borderRadius: '5px',
              border: 'none',
              background: activeTab === 'cases' 
                ? theme.gradients.primary 
                : theme.gradients.secondary,
              color: theme.colors.textWhite,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
            }}
            onClick={() => handleTabClick('cases')}
          >
            <i className={`bi bi-${ClientConfig.nav.cases.icon || 'folder'}`}></i>
            {ClientConfig.nav.cases.label || displayText('My Cases')}
          </button>

          {/* Account Tab */}
          <button
            style={{
              flex: '1 1 0',
              minWidth: '120px',
              padding: '0.5rem',
              fontSize: `${bodyFontSize}px`,
              fontWeight: 'bold',
              borderRadius: '5px',
              border: 'none',
              background: activeTab === 'account' 
                ? theme.gradients.primary 
                : theme.gradients.secondary,
              color: theme.colors.textWhite,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
            }}
            onClick={() => handleTabClick('account')}
          >
            <i className={`bi bi-${ClientConfig.nav.account.icon || 'person'}`}></i>
            {ClientConfig.nav.account.label || 'Account'}
          </button>
        </div>

        {/* Error Message */}
        {error && (
          <div
            style={{
              padding: '0.75rem',
              marginBottom: '1rem',
              border: `1px solid ${theme.colors.errorBorder || '#f5c6cb'}`,
              borderRadius: '5px',
              color: theme.colors.errorText || '#721c24',
              backgroundColor: theme.colors.errorBg || '#f8d7da',
              textAlign: 'center',
            }}
          >
            {error}
          </div>
        )}

        {/* Main Content */}
        <div style={{ width: '100%', boxSizing: 'border-box' }}>
          {renderContent()}
        </div>
      </div>
    );
  };

  export default ClientUserDashboard; 